import {Component, OnInit} from '@angular/core';
import {BreadcrumbService} from "../../service/breadcrumb.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public breadCrumb: BreadcrumbService) {
  }

  ngOnInit() {
    this.breadCrumb.next([]);
  }

}
